export default "__VITE_ASSET__FUq40c0H__"